import {css} from "lit";
import {commonStyles} from "../styles/Common.js";

export const checkboxStyles = [commonStyles, css`
	.pn-checkbox {
		position: relative;
		display: flex;
		align-items: center;
	}
	input {
		position: relative;
		opacity: 0;
		-webkit-appearance: checkbox;
		margin: 0 9px 0 0;
		height: var(--pn-checkbox-size);
		width: var(--pn-checkbox-size);
		z-index: 1; // place it in front of the span so it can be clicked
		flex: 0 0 auto;
	}

	input:checked ~ .custom-checkbox::after,
	input:indeterminate ~ .custom-checkbox::after {
		position: absolute;
		content: "";
		opacity:1;
	}

	input:checked ~ .custom-checkbox::after {
		-webkit-transform: rotate(45deg) scale(1);
		-ms-transform: rotate(45deg) scale(1);
		transform: rotate(45deg) scale(1);
		opacity:1;
		left: 8px;
		top: 3px;
		width: 6px;
		height: 12px;
		border: solid var(--pn-checkbox-check-color);
		border-width: 0 2px 2px 0;
	}

	input:indeterminate ~ .custom-checkbox::after {
		left: 5px;
		top: 10px;
		width: 11px;
		height: 1px;
		border: 1px solid var(--pn-checkbox-check-color);
	}

	input:hover + .custom-checkbox, input:focus + .custom-checkbox {
		border: 1px solid var(--pn-checkbox-check-color);
	}

	.custom-checkbox {
		position: absolute;
		left: 0px;
		height: var(--pn-checkbox-size);
		width: var(--pn-checkbox-size);
		border-radius: 5px;
		border: 1px solid var(--pn-checkbox-box-color);
	}

	.custom-checkbox-label {
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.pn-checkbox .disabled .custom-checkbox border: 1px solid fade(var(--pn-checkbox-box-color, 70%));

	.pn-checkbox .disabled .custom-checkbox:hover {
		border: 1px solid fade(var(--pn-checkbox-box-color, 70%));
	}

	.pn-checkbox .disabled .custom-checkbox-label {
		opacity: 0.7;
	}

	.pn-checkbox :hover .custom-checkbox {
		border: 1px solid var(--pn-checkbox-check-color);
	}

	.error .custom-checkbox {
		border-color: var(--pn-error-msg-light-bg-color);
	}
`];
